import { ErrorHandler, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShowdownModule } from 'ngx-showdown';
import { MatIconRegistry } from '@angular/material/icon';

// 3rd
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// App
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { rootRouterConfig } from './app.routing';
import { AppComponent } from './app.component';
import { MaterialModule } from './shared/material.module';
import { ChunkErrorHandler } from './core/services/chunk-error-handler.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule.forRoot(),
    CoreModule,
    MaterialModule,

    RouterModule.forRoot(rootRouterConfig, {
      useHash: false,
      preloadingStrategy: PreloadAllModules
      //  enableTracing: true
    }),
    ShowdownModule.forRoot({
      flavor: 'github',
      underline: true,
      emoji: true
    })
  ],
  declarations: [AppComponent],
  providers: [
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: ErrorHandler, useClass: ChunkErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
    // Register custom SVG icons for navigation menu
    this.registerNavigationIcons();
  }

  private registerNavigationIcons(): void {
    const iconPath = 'assets/styles/new-theme/svg/';
    const icons = [
      // Ebo + NHS roles
      'dashboard',
      'accounts-setup',
      'audit-logs',
      'performance',
      'dialog-designer',
      'conversations',
      'patient-interactions',
      'test-agent',
      'configurator',
      'reports',
      'data-reporting',
      'waiting-list',
      'hangfire',

      // Clinician only
      'correspondence',
      'care-pathways',

      'ebo-settings',
      'reset-password',
      'logout'
    ];

    icons.forEach(icon => {
      this.iconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(`${iconPath}${icon}.svg`));
    });
  }
}
